module.exports = __webpack_public_path__ + "img/esflag.4e61d720.png";